var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_13270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2134 8.26266C22.7991 7.51673 21.8584 7.24795 21.1125 7.66237L18.6612 9.02423L17.0453 6.55298C16.9975 6.55467 16.9498 6.55664 16.9016 6.55664C15.2741 6.55664 13.8723 5.57452 13.2557 4.1722C11.361 4.17206 8.16351 4.17188 8.16351 4.17188C7.60035 4.17188 7.08182 4.4783 6.81013 4.97156L4.8531 8.52516C4.44149 9.27262 4.7137 10.2122 5.46112 10.6238C5.69746 10.754 5.95302 10.8158 6.20507 10.8158C6.74999 10.8158 7.27837 10.5269 7.5598 10.0158L9.07645 7.26192H11.9944L7.53932 15.0386H2.13782C1.28455 15.0386 0.592773 15.7304 0.592773 16.5837C0.592773 17.4369 1.28451 18.1287 2.13782 18.1287H8.42099C8.96741 18.1287 9.4732 17.8402 9.75116 17.3697L10.861 15.4915L13.663 17.6992L11.9831 21.8786C11.6648 22.6703 12.0486 23.5701 12.8404 23.8883C13.0293 23.9643 13.2243 24.0002 13.4161 24.0002C14.0284 24.0002 14.6079 23.6339 14.8502 23.031L16.9617 17.7779C17.2176 17.1414 17.0232 16.4125 16.4844 15.988L13.3776 13.5402L15.5256 9.87525L16.8616 11.9185C17.1566 12.3697 17.65 12.6182 18.1559 12.6182C18.4103 12.6182 18.6681 12.5553 18.9051 12.4236L22.6132 10.3635C23.3591 9.94922 23.6279 9.00858 23.2134 8.26266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9012 5.15016C18.3234 5.15016 19.4763 3.99725 19.4763 2.57508C19.4763 1.1529 18.3234 0 16.9012 0C15.4791 0 14.3262 1.1529 14.3262 2.57508C14.3262 3.99725 15.4791 5.15016 16.9012 5.15016Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_13270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack);
export default __webpack_public_path__ + "static/media/TRACK.4ec90909301c74f396d5a61260afef69.svg";
export { ForwardRef as ReactComponent };